/* eslint-disable import/prefer-default-export, no-shadow */
export enum FormType {
  THIRDPARTY = 'thirdparty',
  COURT = 'Court',
  FAMILYVIOLENCESCHEME = 'FVS',
  EXTENSION = 'Extension',
  INFRINGEMENTEXTENSION = 'InfringementExtension',
  NOMINATION = 'Nomination',
  INSTALMENT = 'Instalment',
  REVIEW = 'Review',
}
